import { render, staticRenderFns } from "./EduSubjectSelection.vue?vue&type=template&id=285bc25a&"
import script from "./EduSubjectSelection.vue?vue&type=script&lang=ts&"
export * from "./EduSubjectSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports